import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendEmail } from '../../store/thunks/leadsActions';
import EmailMessageBubble from './EmailMessageBubble';

export default function EmailThread({ messages, leadId }) {
  const dispatch = useDispatch();
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyBody, setReplyBody] = useState('');

  if (!messages?.length) {
    return <p className="text-sm text-[#6B7280]">No messages yet.</p>;
  }

return (
  <div className="space-y-6">
    {messages.map(m => {
      const key = m.messageId || m.timestamp;
      const isInbound = m.direction === 'inbound';
      const isReplyBoxOpen = replyingTo === key;

      return (
        <div key={key} className="relative">
          <div className="group">
            <EmailMessageBubble message={m} />

            {isInbound && (
              <button
                onClick={() => setReplyingTo(isReplyBoxOpen ? null : key)}
                className="
                  absolute top-2 right-2 text-xs text-[#2563EB] font-medium
                  opacity-0 group-hover:opacity-100 transition-opacity duration-200
                "
              >
                {isReplyBoxOpen ? 'Cancel' : 'Reply'}
              </button>
            )}
          </div>

          {isInbound && isReplyBoxOpen && (
            <div className="mt-3 ml-6 space-y-3">
              <textarea
                rows={4}
                value={replyBody}
                onChange={e => setReplyBody(e.target.value)}
                placeholder="Type your reply…"
                className="
                  w-full p-3 text-sm border border-[#D1D5DB] rounded-[12px]
                  text-[#1F2937] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#2563EB]
                "
              />
              <button
                onClick={() => {
                  dispatch(
                    sendEmail({
                      leadId,
                      to: Array.isArray(m.from) ? m.from.join(', ') : m.from,
                      subject: m.subject,
                      body: replyBody,
                      threadId: m.threadId
                    })
                  )
                    .unwrap()
                    .then(() => {
                      setReplyBody('');
                      setReplyingTo(null);
                    })
                    .catch(console.error);
                }}
                disabled={!replyBody.trim()}
                className={`
                  px-4 py-2 rounded-[12px] text-sm font-medium transition-colors duration-150
                  ${!replyBody.trim()
                    ? 'bg-[#9CA3AF] text-white cursor-not-allowed'
                    : 'bg-[#2563EB] text-white hover:bg-[#1D4ED8]'
                  }
                `}
              >
                Send
              </button>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

}
